<div class="flex flex-row items-center justify-between">
  <div class="mr-1 text-sm">Period</div>
  <ng-select
    class="w-32"
    bindValue="value"
    [formControl]="periodFormControl"
    [clearable]="false"
    [multiple]="false"
    [searchable]="false"
    [items]="periodList"
  />
</div>
